<template>
  <div class="item_mmct_page">
    <div class="page_top_img_container">
      <img src="@/assets/images/item/sangao_banner.png" class="top_banner">
      <div class="page_content_container">
        <div class="title_with_line">
          <div class="title_line"><span>主要项目</span></div>
          <div class="title_e">Intelligence Project</div>
        </div>
        <div class="content_container">
          <div class="normal_size_font blod_font blue" style="margin-bottom: 1px;">三高慢病管理辅助治疗（三高管理）</div>
          <p class="lineH_desc_16" style="font-size: 14px;">Digital therapeutics to treat chronic diseases, including Type 2 diabetes, Hypertension and Dyslipidemia</p>
          <hr class="blue">
          <p class="lineH_desc_16">建立专业的“三高”（高血压、高血糖、高血脂）慢病管理云平台。运用前沿的数字化诊疗技术对“三高”慢病患者进行风险评估和干预指导，通过线上“三高”共管应用软件辅助医生治疗患者，最终实现对“三高”慢病有效治疗、预防心脑血管疾病的发生。</p>
          <div class="normal_size_font blod_font blue">愿景</div>
          <hr class="blue">
          <p class="lineH_desc_16">希望在健康中国2030计划的框架内，通过建立专业的“三高”慢病管理云平台，推进“三高”共管，开展超重肥胖、血压血糖增高、血脂异常等高危人群的患病风险评估和干预指导，做好高血压、糖尿病、血脂异常的规范化管理。到2022年和2030年，心脑血管疾病死亡率分别下降到209.7/10万及以下和190.7/10万及以下。</p>
          <el-row class="qr_container">
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" v-for="(item,index) in qrcodeList" :key="index">
              <div class="img_container"><img :src="item.imgUrl" style="width:150px"></div>
              <p class="small_size_font">{{item.name}}</p>
            </el-col>
          </el-row>
          <p class="margin_top_set"></p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      qrcodeList:[
        {imgUrl:require('@/assets/images/item/three_high_user_qrcode.png'),name:'安心健康生活（患者版）',width:150},
        {imgUrl:require('@/assets/images/item/three_high_doc_qrcode.png'),name:'安心健康助手（医生版）',width:150}
      ]
    }
  }
}
</script>

<style lang="less">
.item_mmct_page{
  .page_top_img_container{
    .logo_img{
      width: 90%;
      max-width: 267px;
      margin-bottom: 16px;
    }
    .content_container{
      div{
        margin-top: 20px;
        margin-bottom: 13px;
      }
      p{
        padding-bottom: 8px;
      }
    }
    .qr_container{
      display: flex;
      justify-content: center;
      .el-col{
        text-align: center;
        .img_container{
          width: 155px;
          height: 155px;
          margin: 0 auto;
        }
        p{
          color: #000;
        }
      }
    }
  }
  .blue{
    color: #409EFF;
  }
}
</style>

